import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { triggersClient } from '../../../../../../../utils/apollo/api'
import { Absolute } from '../../../../../../../packages/kiti/components/helpers/Position'
import Loading from '../../../../../../../packages/kiti/components/helpers/Loading'
import { useChecklistForm } from '../../../../_form/ChecklistFormHandler'

const Context = React.createContext([])
const { Provider } = Context
export const useTriggersState = () => React.useContext(Context) || {}
export const useTriggers = () => useTriggersState()?.triggers || []

const QUERY = gql`
  query Triggers($filter: TriggerFilter) {
    triggers(limit: 999999, filter: $filter) {
      id
      name
      action
      conditions
      entity
      frequency
      event
      payload
      configuration
      readOnly
      folder {
        id
        name
      }
    }
  }
`

const TriggersLoader = ({ children, isCategory, filter }) => {
  const { triggersCategoryCheckModalOpen, triggersQuestionCheckModalOpen } = useChecklistForm()
  const closedModal = isCategory ? !triggersCategoryCheckModalOpen : !triggersQuestionCheckModalOpen
  const hasQuestionIds = filter.questionIds && !!filter.questionIds.length

  const { data, ...state } = useQuery(QUERY, {
    skip: !hasQuestionIds || closedModal,
    variables: { filter },
    client: triggersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <Provider value={data}>
      {state.loading && (
        <Absolute top="calc(50% - 10px)" right="calc(50% - 10px)">
          <Loading />
        </Absolute>
      )}
      {!state.loading && children}
    </Provider>
  )
}

export default TriggersLoader
